<template>
  <div class="overview">
    <div class="overview-header">
      <div class="overview-header-t">
        <div class="t-item">
          <span class="t-name">任务名称：</span>
          <span class="t-content">{{ baseData.name }}</span>
        </div>
        <div class="t-item">
          <span class="t-name">课程数量：</span>
          <span class="t-content">{{ baseData.courseCount }}</span>
        </div>
        <div class="t-item">
          <span class="t-name">考试数量：</span>
          <span class="t-content">{{ baseData.examCount }}</span>
        </div>
      </div>
      <div class="overview-header-c">
        <div class="t-item">
          <span class="t-name">应参与人数</span>
          <span class="t-content">{{ baseData.total }}</span>
        </div>
        <div class="t-item">
          <span class="t-name">已参与人数</span>
          <span class="t-content">{{ baseData.participationCount }}</span>
        </div>
        <div class="t-item">
          <span class="t-name">未完成数</span>
          <span
            class="t-content"
          >{{ baseData.noneFinishedCount }}</span>
        </div>
        <div class="t-item">
          <span class="t-name">已完成数</span>
          <span class="t-content">{{ baseData.finishedCount }}</span>
        </div>
        <div class="t-item">
          <span class="t-name">考试通过</span>
          <span class="t-content">{{ baseData.passExamCount }}</span>
        </div>
        <div class="t-item">
          <span class="t-name">参与率</span>
          <span class="t-content">{{ baseData.joinRate }}</span>
        </div>
        <div class="t-item">
          <span class="t-name">完成率</span>
          <span class="t-content">{{ baseData.finishedRate }}</span>
        </div>
      </div>
    </div>
    <div class="overview-list">
      <div class="overview-list-t">
        <tab-info txt="员工明细" />
        <export-xlsx :api="api" />
      </div>
      <list-biz
        class="list"
        :config="params.config"
        :data="params.listData"
        :total="params.total"
        :page="params.page"
        @on-current-change="handleOnCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { MBASVCAPIS, ACCOUNTAPIS } from '@api'
import tabInfo from '@components/tab-info'
import exportXlsx from '@components/export-xlsx'
import learnDurationHeader from './components/learn-duration-header'
import scoreHeader from './components/score-header'
import passedExamHeader from './components/passed-exam-header'
import finishedContent from './components/finished-content'
import passedExamContent from './components/passed-exam-content'
import finishedTime from './components/finished-time'

export default {
  components: {
    tabInfo,
    exportXlsx
  },
  data () {
    return {
      baseData: {},
      api: {
        name: MBASVCAPIS.MissionApi.missionEmployeeDetailExportPost,
        params: {
          _id: this.$route.query.id,
          asc: false,
          page: 1,
          pageSize: 10
        }
      },
      params: {
        listData: [],
        config: {
          mode: 'table',
          list: {
            type: 'table',
            columns: [
              {
                prop: 'name',
                label: '姓名',
                // 自定义组件
                component: null,
                showOverflowTooltip: true,
                minWidth: '120'
              },
              {
                prop: 'departmentName',
                label: '部门',
                // 自定义组件
                component: null,
                showOverflowTooltip: true,
                minWidth: '120'
              },
              {
                prop: 'isFinished',
                label: '任务状态',
                // 自定义组件
                component: finishedContent
              },
              {
                prop: 'learnDuration',
                label: '课程学习时长',
                // 自定义组件
                component: null,
                headerComponent: learnDurationHeader,
                width: '140'
              },
              {
                prop: 'score',
                label: '考试分数',
                // 自定义组件
                component: null,
                headerComponent: scoreHeader,
                width: '100'
              },
              {
                prop: 'isPassedExam',
                label: '考试结果',
                // 自定义组件
                component: passedExamContent,
                headerComponent: passedExamHeader,
                width: '100'
              },
              {
                prop: 'finishedTime',
                label: '完成时间',
                // 自定义组件
                component: finishedTime,
                width: '160'
              }
            ]
          }
        },
        total: 0,
        page: 1
      }
    }
  },
  created () {
    this.missionStatisticPost({
      departmentIds: window.departmentIds,
      userIds: window.userIds
    })
    this.missionEmployeeDetailListPost({
      departmentIds: window.departmentIds,
      userIds: window.userIds
    })
    let metas = {}
    if (window.departmentIds.length > 0 || window.userIds.length > 0) {
      metas.departmentIds = window.departmentIds
      metas.userIds = window.userIds
      metas.all = false
    } else {
      metas.all = true
    }
    this.api.params = {
      ...this.api.params,
      ...metas
    }
  },
  methods: {
    update (data) {
      let metas = {}
      if (data && (data.departmentIds.length > 0 || data.userIds.length > 0)) {
        metas.departmentIds = data.departmentIds
        metas.userIds = data.userIds
        metas.all = false
      } else {
        metas.all = true
      }
      this.api.params = {
        ...this.api.params,
        ...metas
      }
      this.params.page = 1
      this.api.params.page = 1
      this.missionStatisticPost(data)
      this.missionEmployeeDetailListPost(data)
    },
    handleOnCurrentChange (e) {
      this.params.page = e
      this.api.params.page = e
      this.api.params = {
        ...this.api.params,
        page: e
      }
      this.missionEmployeeDetailListPost({
        departmentIds: window.departmentIds,
        userIds: window.userIds
      })
    },
    async missionStatisticPost (params) {
      let metas = {
        _id: this.$route.query.id
      }
      if (params && (params.departmentIds.length > 0 || params.userIds.length > 0)) {
        metas.departmentIds = params.departmentIds
        metas.userIds = params.userIds
      } else {
        metas.all = true
      }

      const { success, data } = await MBASVCAPIS.MissionApi.missionStatisticPost(metas)
      if (success) {
        this.baseData = data
      }
    },
    async missionEmployeeDetailListPost (params) {
      let metas = {
        _id: this.$route.query.id,
        page: this.params.page,
        pageSize: 10
      }
      if (params && (params.departmentIds.length > 0 || params.userIds.length > 0)) {
        metas.departmentIds = params.departmentIds
        metas.userIds = params.userIds
        metas.all = false
      } else {
        metas.all = true
      }
      const { success, data } = await MBASVCAPIS.MissionApi.missionEmployeeDetailListPost(metas)
      if (success) {
        this.params.listData = data.data
        this.params.total = data.total
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.overview {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 20px;

  .overview-header {
    width: calc(100% - 40px);
    margin: 0 auto;
    border-radius: 4px;
    border: 1px solid #e8e8e8;

    .overview-header-t {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #fafafa;
      border-radius: 4px 4px 0 0;
      border-bottom: 1px solid #e8e8e8;

      .t-item {
        display: flex;
        flex-basis: 28.5%;
        margin-left: 20px;

        .t-name {
          color: #595959;
          font-size: 13px;
        }

        .t-content {
          color: #262626;
          font-size: 13px;
        }
      }
    }

    .overview-header-c {
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .t-item {
        flex: 1;
        text-align: center;
        align-items: center;
        box-sizing: border-box;
        border-right: 1px solid #e8e8e8;

        .t-name {
          font-size: 12px;
          color: #8c8c8c;
          display: block;
        }

        .t-content {
          font-size: 13px;
          color: #262626;
          display: block;
          height: 14px;
          margin-top: 8px;
        }
      }
    }
  }

  .overview-list {
    height: calc(100% - 200px);

    .overview-list-t {
      width: calc(100% - 40px);
      height: 28px;
      display: flex;
      justify-content: space-between;
      margin: 35px 20px 10px 20px;
    }

    .list {
      width: calc(100% - 40px);
      margin: 0 auto;
    }
  }
}
</style>
